import React from 'react'

const IconSuccess = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
    </svg>
)

const IconDanger = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
)

const IconWarning = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
)

const IconClose = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
)

interface UserMessageProps {
    type: string
    children: React.ReactNode
    inline?: boolean
    label?: string
    role?: 'alert' | 'status'
    onClose?: () => void
}

export const UserMessage: React.FC<UserMessageProps> = ({ type, children, inline = false, label, role, onClose }) => (
    <section className={`user-msg open ${type}${inline ? ' user-msg--inline' : ''}`} aria-label={label} role={role}>
        <span className="msg-icon" aria-hidden="true">
            {type === 'success' ? <IconSuccess /> : type === 'warning' ? <IconWarning /> : <IconDanger />}
        </span>
        <div className="msg-text">{children}</div>
        {onClose && <button className="close-btn" aria-label="Dismiss notification" onClick={(ev) => { ev.stopPropagation(); onClose() }}>
            <IconClose />
        </button>}
    </section>
)
